import React from 'react';
import { Dialog } from '../ui/components/Dialog';
import { CollectionAnalyticsChart } from './charts/CollectionAnalyticsChart';
import { RarityPriceScatterChart } from './charts/RarityPriceScatterChart';
import { FeatherX, FeatherBarChart2 } from '@subframe/core';

interface FloorPriceHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  collectionId: string;
  collectionName?: string;
  collectionSize?: number;
  hasRarity?: boolean;
}

export const FloorPriceHistoryModal: React.FC<FloorPriceHistoryModalProps> = ({
  isOpen,
  onClose,
  collectionId,
  collectionName,
  collectionSize,
  hasRarity = true,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Content className="w-full max-w-[720px]">
        <div className="flex w-full flex-col items-start gap-4 p-6">
          {/* Header */}
          <div className="flex w-full items-start justify-between">
            <div className="flex flex-col items-start gap-1">
              <div className="flex items-center gap-2">
                <FeatherBarChart2 className="h-5 w-5 text-brand-600" />
                <span className="text-heading-2 font-heading-2 text-default-font">
                  Collection Analytics
                </span>
              </div>
              {collectionName && (
                <span className="text-body font-body text-subtext-color">
                  {collectionName}
                </span>
              )}
            </div>
            <button
              type="button"
              onClick={onClose}
              className="flex h-8 w-8 items-center justify-center rounded hover:bg-neutral-100"
            >
              <FeatherX className="h-5 w-5 text-subtext-color" />
            </button>
          </div>

          {/* Rarity vs Price Scatter Chart - only show if collection has rarity */}
          {hasRarity && (
            <div className="w-full">
              <RarityPriceScatterChart collectionId={collectionId} collectionSize={collectionSize} />
            </div>
          )}

          {/* Combined Analytics Chart */}
          <div className="w-full">
            <CollectionAnalyticsChart collectionId={collectionId} />
          </div>

          {/* Legend */}
          <div className="flex w-full items-center gap-6 text-caption font-caption text-subtext-color">
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-[#10b981]" />
              <span>Floor Price (XRP)</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-[#3b82f6]" />
              <span>Volume (XRP)</span>
            </div>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  );
};
